export default __webpack_public_path__ + "static/media/(18).125e3bff.JPG";